export default "__VITE_ASSET__sh8xP9$9__"